export function toolbarClose(): ng.IDirective {
    return {
        restrict: "E",
        template: require('./toolbarClose.html')
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/toolbarClose.directive.ts
 **/